<template>
    <div class="cus-content ck-content" v-html="content"></div>
</template>

<script>
export default {
    name: 'CkContentComponent',
    components: {},
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    computed: {},
    mounted() {
        setTimeout(() => {
            const hrefPoints = document.querySelectorAll('a[data-tag="hrefPoint"]')
            for (let i = 0; i < hrefPoints.length; i++) {
                hrefPoints[i].setAttribute('id', hrefPoints[i].getAttribute('href'))
            }
        }, 200)
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.cus-content {
    margin-top: 0.4rem;
    padding: 0 0.2rem;
    padding-bottom: 0.4rem;
    position: relative;
    >>> h2 {
        font-size: 0.34rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ckeditor-content/index.vue